// Product data structure - Content is now managed via translation files
// This file only contains non-translatable data (IDs, categories, capacities, images, colors)

export const products = [
  // Wheelie Bins - Small (60L, 90L)
  {
    id: '1',
    category: 'wheelie-bin',
    capacity: '60L',
    capacityValue: 60,
    type: 'residential',
    colors: ['Green', 'Blue', 'Black', 'Gray', 'Brown', 'Red', 'Orange', 'Yellow'],
    materials: ['original', 'recycled'],
    image: '/assets/Blue.png',
    image2: '/assets/Grey.png',
    image3: '/assets/Red.png',
    customization: ['customColors', 'logoPrinting', 'rfidTags'],
    price: 'Request Quote'
  },
  {
    id: '2',
    category: 'wheelie-bin',
    capacity: '90L',
    capacityValue: 90,
    type: 'residential',
    colors: ['Green', 'Blue', 'Black', 'Gray', 'Brown', 'Red', 'Orange', 'Yellow'],
    materials: ['original', 'recycled'],
    image: '/assets/Green.png',
    image2: '/assets/Blue.png',
    image3: '/assets/Grey.png',
    customization: ['customColors', 'logoPrinting', 'rfidTags'],
    price: 'Request Quote'
  },
  // Wheelie Bins - Medium (120L, 240L)
  {
    id: '3',
    category: 'wheelie-bin',
    capacity: '120L',
    capacityValue: 120,
    type: 'municipal',
    colors: ['Green', 'Blue', 'Black', 'Gray', 'Brown', 'Red', 'Orange', 'Yellow'],
    materials: ['original', 'recycled'],
    image: '/assets/Grey.png',
    image2: '/assets/Green.png',
    image3: '/assets/Red.png',
    customization: ['customColors', 'logoPrinting', 'rfidTags', 'pedalOperation'],
    price: 'Request Quote'
  },
  {
    id: '4',
    category: 'wheelie-bin',
    capacity: '240L',
    capacityValue: 240,
    type: 'municipal',
    colors: ['Green', 'Blue', 'Black', 'Gray', 'Brown', 'Red', 'Orange', 'Yellow'],
    materials: ['original', 'recycled'],
    image: '/assets/Red.png',
    image2: '/assets/Grey.png',
    image3: '/assets/Blue.png',
    customization: ['customColors', 'logoPrinting', 'rfidTags', 'lockingSystem'],
    price: 'Request Quote'
  },
  // Wheelie Bins - Large Industrial (660L)
  {
    id: '5',
    category: 'wheelie-bin',
    capacity: '660L',
    capacityValue: 660,
    type: 'industrial',
    colors: ['Green', 'Blue', 'Black', 'Gray', 'Brown', 'Red', 'Orange', 'Yellow'],
    materials: ['original', 'recycled'],
    image: '/assets/Green660.png',
    image2: '/assets/Grey660.png',
    image3: '/assets/Yellow660.png',
    customization: ['customColors', 'logoPrinting', 'rfidTags', 'lockingSystem', 'drainagePlugs'],
    price: 'Request Quote'
  },
  // Recycle Bins - Individual
  {
    id: '6',
    category: 'recycle-bin',
    capacity: '50L',
    capacityValue: 50,
    type: 'residential',
    colors: ['Green', 'Blue', 'Black', 'Gray', 'Brown', 'Red', 'Orange', 'Yellow'],
    materials: ['original', 'recycled'],
    image: '/assets/recycle_green.png',
    image2: '/assets/recycle_duo.png',
    image3: '/assets/recycle_yellow.png',
    customization: ['colorCoding', 'logoPrinting', 'recyclingSymbols'],
    price: 'Request Quote'
  },
  {
    id: '7',
    category: 'recycle-bin',
    capacity: '70L',
    capacityValue: 70,
    type: 'municipal',
    colors: ['Green', 'Blue', 'Black', 'Gray', 'Brown', 'Red', 'Orange', 'Yellow'],
    materials: ['original', 'recycled'],
    image: '/assets/recycle_green.png',
    image2: '/assets/recycle_duo.png',
    image3: '/assets/recycle_yellow.png',
    customization: ['colorCoding', 'logoPrinting', 'recyclingSymbols', 'lids'],
    price: 'Request Quote'
  },
  // Recycle Bin Sets
  {
    id: '12',
    category: 'recycle-set',
    capacity: '3x50L',
    capacityValue: 150,
    type: 'municipal',
    setSize: 3,
    colors: ['Green', 'Blue', 'Black', 'Gray', 'Brown', 'Red', 'Orange', 'Yellow'],
    materials: ['original', 'recycled'],
    image: '/assets/recycle_duo.png',
    image2: '/assets/recycle_green.png',
    image3: '/assets/recycle_yellow.png',
    customization: ['colorCoding', 'logoPrinting', 'recyclingSymbols', 'labelStickers'],
    price: 'Request Quote'
  },
  {
    id: '13',
    category: 'recycle-set',
    capacity: '3x70L',
    capacityValue: 210,
    type: 'municipal',
    setSize: 3,
    colors: ['Green', 'Blue', 'Black', 'Gray', 'Brown', 'Red', 'Orange', 'Yellow'],
    materials: ['original', 'recycled'],
    image: '/assets/recycle_duo.png',
    image2: '/assets/recycle_green.png',
    image3: '/assets/recycle_yellow.png',
    customization: ['colorCoding', 'logoPrinting', 'recyclingSymbols', 'labelStickers', 'lids'],
    price: 'Request Quote'
  },
  {
    id: '15',
    category: 'recycle-set',
    capacity: '4x50L',
    capacityValue: 200,
    type: 'municipal',
    setSize: 4,
    colors: ['Green', 'Blue', 'Black', 'Gray', 'Brown', 'Red', 'Orange', 'Yellow'],
    materials: ['original', 'recycled'],
    image: '/assets/recycle_duo.png',
    image2: '/assets/recycle_green.png',
    image3: '/assets/recycle_yellow.png',
    customization: ['colorCoding', 'logoPrinting', 'recyclingSymbols', 'labelStickers'],
    price: 'Request Quote'
  },
  {
    id: '16',
    category: 'recycle-set',
    capacity: '4x70L',
    capacityValue: 280,
    type: 'industrial',
    setSize: 4,
    colors: ['Green', 'Blue', 'Black', 'Gray', 'Brown', 'Red', 'Orange', 'Yellow'],
    materials: ['original', 'recycled'],
    image: '/assets/recycle_duo.png',
    image2: '/assets/recycle_green.png',
    image3: '/assets/recycle_yellow.png',
    customization: ['colorCoding', 'logoPrinting', 'recyclingSymbols', 'labelStickers', 'lids'],
    price: 'Request Quote'
  },
  // Barrels
  {
    id: '9',
    category: 'barrel',
    capacity: '200L',
    capacityValue: 200,
    type: 'industrial',
    colors: ['Blue', 'Black', 'White'],
    materials: ['original', 'recycled'],
    image: '/assets/barrel.png',
    image2: 'https://wearvalleytanks.co.uk/wp-content/uploads/2025/05/60-Litre-Barrel-Wear-Valley-Tanks.jpg',
    image3: 'https://t3.ftcdn.net/jpg/00/49/47/90/360_F_49479037_BbY2XawHpfW8ZlFg4vmY0gB549jAehCg.jpg',
    customization: ['customColors', 'logoPrinting', 'lockingLids', 'spillContainment'],
    price: 'Request Quote'
  },
  {
    id: '10',
    category: 'barrel',
    capacity: '120L',
    capacityValue: 120,
    type: 'industrial',
    colors: ['Blue', 'Black', 'White'],
    materials: ['original', 'recycled'],
    image: '/assets/barrel.png',
    image2: 'https://wearvalleytanks.co.uk/wp-content/uploads/2025/05/60-Litre-Barrel-Wear-Valley-Tanks.jpg',
    image3: 'https://t3.ftcdn.net/jpg/00/49/47/90/360_F_49479037_BbY2XawHpfW8ZlFg4vmY0gB549jAehCg.jpg',
    customization: ['customColors', 'logoPrinting', 'lockingLids'],
    price: 'Request Quote'
  },
  {
    id: '11',
    category: 'barrel',
    capacity: '60L',
    capacityValue: 60,
    type: 'industrial',
    colors: ['Blue', 'Black', 'White'],
    materials: ['original', 'recycled'],
    image: '/assets/barrel.png',
    image2: 'https://wearvalleytanks.co.uk/wp-content/uploads/2025/05/60-Litre-Barrel-Wear-Valley-Tanks.jpg',
    image3: 'https://t3.ftcdn.net/jpg/00/49/47/90/360_F_49479037_BbY2XawHpfW8ZlFg4vmY0gB549jAehCg.jpg',
    customization: ['customColors', 'logoPrinting', 'lockingLids', 'handles'],
    price: 'Request Quote'
  }
];

export const applications = [
  {
    id: '1',
    image: 'https://customer-assets.emergentagent.com/job_garbagegenius/artifacts/cghx6rxd_660-770-lt..png'
  },
  {
    id: '2',
    image: '/assets/Red.png'
  },
  {
    id: '3',
    image: '/assets/barrel.png'
  }
];

export const companyInfo = {
  name: 'E&O',
  email: 'info@eobins.org',
  phone: '+90 534 529 86 85',
  address: 'Malkara OSB Tekirdağ Türkiye'
};
